"use strict";

var _require = require('lodash'),
    sortBy = _require.sortBy;

var moment = require('moment');

var PrintingOption = require('./PrintingOption');

module.exports = function (order, services) {
  var values;

  if (order.has_letterpress) {
    values = services.letterpress;
  } else {
    values = services.standard;
  }

  var order_date = moment(order.order_date);
  values = sortBy(values, 'timestamp').filter(function (_ref) {
    var timestamp = _ref.timestamp;
    return moment(timestamp).isBefore(order_date);
  });

  if (values.length === 0) {
    throw new Error("no matching printing options found for order_date ".concat(order_date.toISOString()));
  }

  return values[values.length - 1].options.map(function (opt) {
    return new PrintingOption(opt);
  });
};